export const safeAreaTop = () =>
	Math.max(
		0,
		parseFloat(
			getComputedStyle(document.documentElement)
				.getPropertyValue('--safe-area-top')
				.replace('px', '')
		) - 10 // This arbitrary 10px is so it looks a bit better
	);

export const areValuesEqual = (value1: unknown, value2: unknown): boolean => {
	// Handle null/undefined equality
	if (value1 == null && value2 == null) return true;
	if (value1 == null || value2 == null) return false;

	// Handle Date objects
	if (value1 instanceof Date && value2 instanceof Date) {
		return value1.toISOString() === value2.toISOString();
	}

	return value1 === value2;
};

export const cleanCode = (code: string) => {
	return code.split('/').pop() || '';
};
